
// ------ buy nav constants
const NAV_BASE = '/buy';

export const NAV_BUY_OVERVIEW_PAGE = NAV_BASE;

export const NAV_SEARCH_PAGE = `${NAV_BASE}/search`;
